import React, { PropTypes, Component } from 'react';
import EntitiesListHorizontolContainer from './EntitiesListHorizontolContainer';
import Notification from './Notification';
import { loadMoreServices } from '../actions/WebsiteLoadCreator';
import Loader from 'react-loader';

class Services extends Component {
  static propTypes = {
    entities: PropTypes.array.isRequired,
  }

  static defaultProps = {
    entities: [],
  }
  static contextTypes = {
    executeAction: React.PropTypes.func
  }

  render() {
    var entites = this.props.entities;
    return (
      <div className='container-fluid' style={ { 'padding': '0px', 'overflow': 'hidden' } }>
        <div className='row-fluid clearfix'>
          <Notification notifications={ [] } />
          <div className='col-md-9'>
            <div className='container-fluid container-border'>
              <div className='row-fluid row1'>
                <div className='col-md-12' style={ { 'paddingLeft': '0px' } }>
                  <a className='category-breadcumb' style={ { 'paddingBottom': '0px' } } href='/'>
                                              Home
                                          </a> /
                  <a className='category-breadcumb' style={ { 'paddingBottom': '0px' } } href='/services'>
                                              Services
                                          </a>
                  <div className='category-title landing-title'>
                    SERVICES
                  </div>
                </div>
              </div>
              { entites.map(function(entity, index) {
                  return (
                    <div>
                      <EntitiesListHorizontolContainer entities={ entity } />
                      { (index !== entites.length - 1) && (
                        <div className='row-fluid'>
                          <div className='col-md-12 item-padding'>
                            <div className='category-border'></div>
                          </div>
                        </div>
                        ) }
                    </div>
                    );
                }) }
              <div className='row-fluid'>
                <div className='col-md-12 loadmore'>
                  <div className='loadmore-button' onClick={ this.loadServices.bind(this, entites) }>load more</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      );
  }
  loadServices(entities) {
    this.context.executeAction(loadMoreServices, {
      limit: entities.length
    });
  }
}


module.exports = Services;



// WEBPACK FOOTER //
// ./src/components/Services.js